import axios from 'axios';

export const CustomApi = axios.create({
  baseURL: '/',
  headers: { 'Content-Type': 'application/json' },
  timeout: 60000,
  // withCredentials: true,
});

CustomApi.interceptors.request.use((config) => {
  const TOKEN_TYPE = localStorage.getItem('tokenType');
  const TOKEN = localStorage.getItem('admin-accessToken');
  if (TOKEN) {
    config.headers['Authorization'] = `${TOKEN_TYPE} ${TOKEN}`;
  }
  return config;
});

CustomApi.interceptors.response.use(
  (response) => {
    if (response.headers['authorization']) {
      localStorage.setItem('accessToken', response.headers['authorization'].slice(7));
    }
    return response;
  },
  async (error) => {
    if (error.response.status === 401) {
      localStorage.clear();
      window.location.href = `/`;
    } else if (error.response.status === 403) {
      localStorage.clear();
      window.location.href = `/`;
    }
    return Promise.reject(error);
  }
);
